import { engineComponent, ArrayUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { AnimatedPaylineNumber } from "./AnimatedPaylineNumber";
import { AnimatedPaylinePart } from "./AnimatedPaylinePart";

@engineComponent(ComponentTypes.DisplayObject)
export class AnimatedPayline extends ContainerElement {
    private _valuesX: Array<number> = [];
    private _valuesY: Array<number> = [];
    private _tints: Array<string> = [];
    private _childNode: Element;

    constructor() {
        super();
    }

    public createByNode(node: Element) {
        super.createByNode(node);

        if (node.hasAttribute("ValuesX")) {
            this._valuesX = ArrayUtils.numberArray(node.getAttribute("ValuesX"));
        }

        if (node.hasAttribute("ValuesY")) {
            this._valuesY = ArrayUtils.numberArray(node.getAttribute("ValuesY"));
        }

        if (node.hasAttribute("Tints")) {
            this._tints = node.getAttribute("Tints").split(";");
        }

        if (node.hasChildNodes()) {
            this._childNode = node.firstElementChild;
        }

        this.createChilds();
    }

    public updateByNode(node: Element) {
        if (node.hasAttribute("Method")) {
            switch (node.getAttribute("Method")) {
                case "stop":
                    this.stop();
                    break;
                case "win":
                    this.win();
                    break;
            }
        }
    }

    public stop(): void {
        this.visible = false;
        for (let i: number = 0; i < this.children.length; i++) {
            (this.children[i] as AnimatedPaylinePart).stop();
        }
    }

    public win(): void {
        this.visible = true;
        for (let i: number = 0; i < this.children.length; i++) {
            (this.children[i] as AnimatedPaylinePart).animateWin();
        }
    }

    public clone(): AnimatedPayline {
        const element: AnimatedPayline = new AnimatedPayline();
        element.x = this.x;
        element.y = this.y;
        element._valuesX = this._valuesX;
        element._valuesY = this._valuesY;
        element._tints = this._tints;
        element._childNode = this._childNode;
        element.createChilds();
        return element;
    }

    private createChilds(): void {
        if (this._valuesX != null && this._valuesX.length > 0 && this._childNode != null) {
            for (let i: number = 0; i < this._valuesX.length; i++) {
                let part: AnimatedPaylinePart = new AnimatedPaylinePart();
                let randomOffsetX: number = this.getRandom(-6, 6);
                let randomOffsetY: number = this.getRandom(-6, 6);

                part.x = this._valuesX[i] + randomOffsetX;
                if (this._valuesY[i] != null) {
                    part.y = this._valuesY[i] + randomOffsetY;
                }
                part.createByNode(this._childNode);
                let randomScale: number = this.getRandom(-2, 2) / 10;
                part.children[0].scale.x += randomScale;
                part.children[0].scale.y += randomScale;
                part.tints(this._tints);
                this.addChild(part);
            }
        }
    }

    public getRandom(min: number, max: number): number {
        return Math.random() * (max - min) + min;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/AnimatedPayline.ts
 **/